import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { store } from "../../../../shared/store";
import GivingButtonV2 from "./GivingButtonV2";

const CampaignShowGivingButtonV2 = ({ buttonText, campaign, cssClasses, entityId }) => {
  if (campaign.external_donation_url) {
    return (
      <a
        data-testid="t-giving-form-v2--Campaig-a"
        className="btn btn-primary m-sm-r giving-nav-giving-btn"
        href={campaign.external_donation_url}>
        {buttonText || "GIVE"}
      </a>
    );
  } else {
    return (
      <Provider store={store}>
        <BrowserRouter>
          <GivingButtonV2
            entityId={entityId}
            campaign={campaign}
            cssClasses={cssClasses}
            buttonText={buttonText}
          />
        </BrowserRouter>
      </Provider>
    );
  }
};

export default CampaignShowGivingButtonV2;
